<template>
  <section class="detail_content">
    <div
      class="categoryList_card flx"
      v-if="subCategoryList.length > 0"
      v-for="(subCategory,index) in subCategoryList"
      :key="index"
      @click="goToGetProductByCategory(subCategory.id,subCategory.name)"
    >
      <span class="img_wrapper spinner_wrapper" v-lazyload v-if="subCategory.bgImageURL">
        <ImageSpinner class="image_spinner" />
        <img :data-url="subCategory.bgImageURL" alt />
      </span>
      <div class="product_detail">
        <p>{{subCategory.name}}</p>
      </div>
      <span class="go_detail_listing">
        <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
      </span>
    </div>
    <div  v-if="noRecordFound == true" class="no_record">
        <div class="page-status-panel">
          <div class="img-block">
            <img src="../../assets/images/icons/norecord.svg" alt />
          </div>
          <div class="details-block">
            <h2>No Records Found</h2>
            <p>There was no record found that will you enter here.</p>
          </div>
        </div>
      </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "SubCategoryListing",
  components: {
    ImageSpinner
  },
  data() {
    return {
      subCategoryList: [],
      loading: false,
      noRecordFound: false
    };
  },
  methods: {
    getAllCategories() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getAllCategories",
          payload: this.$route.params.subcategoryid
        })
        .then(data => {
          this.loading = false;
          this.subCategoryList = data.data.childCategories;
          if (this.subCategoryList == null) {
            this.noRecordFound = true
          }
          this.$store.commit("saveCategoryList", {
            categoryList: this.subCategoryList
          });
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToGetProductByCategory(categoryId, name) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push(
        "/product-by-category?type=NORMAL&categoryid=" + categoryId
      );
    }
  },
  mounted() {
    this.getAllCategories();
    // if(this.$store.getters.categoryList.length > 0){
    //   this.subCategoryList = this.$store.getters.categoryList
    // }else{
    //   this.getAllCategories()
    // }
  }
};
</script>
    